import { AnalyticsEvents, trackEvent } from "./analytics";
import { getScheduleFilterAnalyticsParams } from "./scheduleFilterAnalyticsParams";

export const trackHomeClassFinderSubmit = (programName, filter) => {
  trackEvent(AnalyticsEvents.HOME_CLASS_FINDER_SUBMIT, {
    item_name: programName,
    location: "/",
    ...getScheduleFilterAnalyticsParams(filter),
  });
};
